import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewUnitList = (unitData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_UNIT_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/unit/list`,
        unitData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_UNIT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_UNIT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_UNIT_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewUnitListNoPagination = (optionalPayload = {}) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_UNIT_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/unit/alllist`,
        optionalPayload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_UNIT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_UNIT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_UNIT_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewUnit = (unitData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_UNIT_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/unit/${unitData}`,
        unitData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_UNIT_SUCCESS", payload: data });

        return data;
      } else {
        dispatch({ type: "VIEW_UNIT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_UNIT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    }
  };
};

export const addNewUnit = (unitData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_UNIT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/unit/add`,
        unitData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_UNIT_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_UNIT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_UNIT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    }
  };
};

export const editUnit = (unitData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "EDIT_UNIT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/unit/update`,
        unitData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_UNIT_SUCCESS", payload: data });
        toast.success("Edit Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_UNIT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_UNIT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    }
  };
};
